<template>
  <section class="banner">
    <div class="container"
         data-aos="fade-right">
      <a-typography-title :level="1">
        <span>Empower your enterprise with</span>
        <br v-if="$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)" />
        <span>a powerful Serverless AI application platform</span>
      </a-typography-title>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_1"
                  @click="$router.push({hash:'#footer'})">
          Get started
        </a-button>
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'home_banner'
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}overseas/home/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: 150px 0 80px;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(left, @banner_title+@line, @color_white, @banner_title, true);
  text-shadow: 0 2px 5px fade(#10388C, 100);
}

.ant-space {
  margin: @margin 0 0;
  
  .button_n_1 {
    max-width: 100%;
    width: 300px !important;
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 80px 0 30px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .banner {
    .container {
      text-align: center;
    }
  }
  
  h1.ant-typography {
    .font(left, @banner_title_mo+@line_mo, @color_white, @banner_title_mo, true);
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>